import React from 'react'
import PropTypes from 'prop-types'
import { formatMoney } from '../../../../util/money'


const SalesOrderPriceTable = ({ salesOrder }) => {
    return (
        <table className="sales-order-price-table">
            <tbody>
                <tr>
                    <td>Brut</td>
                    <td>{formatMoney(salesOrder.brutPrice, salesOrder.currency)}</td>
                </tr>
                <tr>
                    <td>Net</td>
                    <td>{formatMoney(salesOrder.netPrice, salesOrder.currency)}</td>
                </tr>
                <tr>
                    <td>VAT</td>
                    <td>{formatMoney(salesOrder.vat, salesOrder.currency)}</td>
                </tr>
                <tr>
                    <td>Voucher</td>
                    <td>{salesOrder.voucherCode || 'none'}</td>
                </tr>
            </tbody>
        </table>
    )
}

SalesOrderPriceTable.propTypes = {
    salesOrder: PropTypes.object.isRequired,
}


export default SalesOrderPriceTable



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/detail/SalesOrderPriceTable.js